import React, { useState, useEffect, Fragment } from 'react';
import { makeStyles } from "@material-ui/core/styles";

import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Alert from '@material-ui/lab/Alert';

import useQuery from 'app/hooks/useQuery';
import useApi from 'app/context/useApi';
import useApp from 'app/context/useApp';

import PasswordPatterns from 'app/utils/PasswordPatterns';

const useStyles = makeStyles(theme => ({
    submit: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    marginTop: {
        marginTop: theme.spacing(2),
    },
    passwordHeader: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2)
    },
    dividerTop: {
        marginTop: theme.spacing(1),
    },
    divider: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    }
}));

export default function ResetForm (props) {

    const [ token, setToken ] = useState(null);
    const [ email, setEmail ] = useState(null);

    const [ password, setPassword ] = useState("");
    const [ passwordConfirmation, setPasswordConfirmation ] = useState("");
    const [ persistLogin, setPersistLogin ] = useState(true);

    const [ error, setError ] = useState(null);

    const classes = useStyles();
    const query = useQuery();
    const { onLoading, loading } = props;
    const api = useApi();
    const { app } = useApp();

    useEffect(() => {

        const queryToken = query.get('token');
        const queryEmail = query.get('email');

        if (queryToken) setToken(queryToken);
        if (queryEmail) setEmail(queryEmail);

    }, []);

    const handlePassword = e => {

        const value = e.target.value;

        if (error) setError(null);

        setPassword(value);
    };

    const handlePasswordConfirmation = e => {

        const value = e.target.value;

        if (error) setError(null);

        setPasswordConfirmation(value);
    };

    const handlePersistLogin = () => {

        setPersistLogin(! persistLogin);
    };

    const postPasswordReset = e => {

        e.preventDefault()

        onLoading(true);
        setError(null);

        const data = {
            email: email,
            token: token,
            password: password,
            password_confirmation: passwordConfirmation,
            persist_login: persistLogin,
            club_id: app.club ? app.club.id : 0
        }

        api.post(process.env.MIX_WEB_BASEURL + '/reset', data)
            .then(() => hydrateApp())
            .catch(error => {
                onLoading(false);
                if (error?.response?.data?.errors) setError(error.response.data.errors['password'][0]);
            });
    }

    const matchesPattern = pattern => {
        return pattern.test(password)
    }

    const checkPassword = () => {
        return (password === passwordConfirmation)
    }

    return (
        <div className={classes.form}>
            <form noValidate>
                <Typography variant="subtitle2" align="center" color="textPrimary">
                    Reset your password below:
                </Typography>
                <div className={classes.marginTop}/>
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            id="input-password"
                            label="Password"
                            value={password}
                            onChange={handlePassword}
                            fullWidth
                            type="password"
                            variant="outlined"
                            margin="normal"
                            color="secondary"
                        />
                        <TextField
                            id="input-check-password"
                            label="Confirm Password"
                            value={passwordConfirmation}
                            onChange={handlePasswordConfirmation}
                            fullWidth
                            type="password"
                            error={!checkPassword()}
                            helperText={checkPassword() ? "" : "Passwords do not match"}
                            variant="outlined"
                            margin="normal"
                            color="secondary"
                        />
                        {error &&
                            <div className={classes.marginTop}>
                                <Alert severity="error">{error}</Alert>
                            </div>
                        }
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography className={classes.passwordHeader} gutterBottom variant="body2" color="textSecondary">
                            Your password must:
                        </Typography>
                        {PasswordPatterns.map((p, i) => (
                            <Fragment key={i}>
                                <Typography
                                    gutterBottom
                                    variant="body2"
                                    color={matchesPattern(p.regex) ? 'primary' : 'error'}
                                    >
                                    {p.label}
                                </Typography>
                                { (i < (PasswordPatterns.length - 1)) &&
                                    <Divider className={classes.divider}/>
                                }
                            </Fragment>
                        ))}
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormControlLabel
                            control={
                                <Checkbox checked={persistLogin} onChange={handlePersistLogin} name="persistLogin" />
                            }
                            label="Stay Logged In?"
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Button
                            variant="contained"
                            color="secondary"
                            onClick={postPasswordReset}
                            fullWidth
                            disabled={loading}
                            >
                            Reset Password
                        </Button>
                    </Grid>
                </Grid>
            </form>
        </div>
    );
}
